import styled from "styled-components";
import {FreePlayContainerDefaultBox} from "./free-play-container.default.box";

export const FreePlayContainerMrGreenCisBox = styled(FreePlayContainerDefaultBox)`
    background-color: ${({theme}) => theme.colors.brandPrimaryDark};
`;